<template>
  <div>
    <MultiTripSegmentRow
      v-for="(routeItem, segmentIndex) in routes"
      :key="routeItem.id"
      :dep="routeItem.dep"
      :arr="routeItem.arr"
      :dates="routeItem.dates"
      :segment-index="segmentIndex"
      :source="source"
      :validation="getDirectionValidation(segmentIndex)"
      @onFromInputClick="emit('onFromSheet', segmentIndex)"
      @onToInputClick="emit('onToSheet', segmentIndex)"
      @onSwap="emit('onSwap', segmentIndex)"
      @onDateSelect="mode => emit('onOpenCalendar', segmentIndex, mode)"
      @onOpenInfo="emit('onOpenMultiTripInfo')"
      @onRemove="emit('onRemoveLeg', routeItem.id)"
    />

    <MultiTripSearchEntry
      v-if="showAddAnother && canAddRoute"
      :disabled="!canAddRoute"
      @onClick="emit('onAddLeg')"
    >
      <template #icon>
        <PlusIcon class="h-6 w-6" />
      </template>
      {{ $t(addAnotherLabelKey) }}
    </MultiTripSearchEntry>
  </div>
</template>

<script setup lang="ts">
  import type { searchFormCalendar, RouteState } from 'shared';

  import PlusIcon from '@/assets/images/multi-trip/plus-icon-24x24.svg?component';

  import MultiTripSearchEntry from './MultiTripSearchEntry.vue';
  import MultiTripSegmentRow from './MultiTripSegmentRow.vue';

  type SegmentValidation = {
    dep?: { $error?: boolean };
    arr?: { $error?: boolean };
  };

  defineProps<{
    source: string;
    routes: RouteState[];
    getDirectionValidation: (segmentIndex: number) => SegmentValidation;
    canAddRoute: boolean;
    showAddAnother: boolean;
    addAnotherLabelKey: string;
  }>();

  const emit = defineEmits<{
    onFromSheet: [segmentIndex: number];
    onToSheet: [segmentIndex: number];
    onSwap: [segmentIndex: number];
    onOpenCalendar: [
      segmentIndex: number,
      mode: searchFormCalendar.config.CalendarMode,
    ];
    onAddLeg: [];
    onOpenMultiTripInfo: [];
    onRemoveLeg: [routeId: string];
  }>();
</script>
